import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import HeroSection from "./components/HeroSection";
import LocationsCarousel from "./components/LocationsCarousel";

const NewApartments = () => {
  const [activeTab, setActiveTab] = useState("New Apartments");
  const navigate = useNavigate();
  const userId = localStorage.getItem("userId") || "";

  const onLocationClick = (location) => {
    const params = new URLSearchParams({ tab: "list", category: activeTab, location: location.toLowerCase() });
    if (userId) params.set("userId", userId);
    navigate(`/new-homes/map?${params.toString()}`);
  };

  return (
    <main>
      <HeroSection activeTab={activeTab} setActiveTab={setActiveTab} />
      <div className="bg-white">
        <LocationsCarousel
          activeTab={activeTab}
          onExploreMap={() => {
            const params = new URLSearchParams({ tab: "map", category: activeTab });
            if (userId) params.set("userId", userId);
            navigate(`/new-homes/map?${params.toString()}`);
          }}
          onLocationClick={onLocationClick}
        />
      </div>
    </main>
  );
};

export default NewApartments;
